import React from 'react'

const Calculator = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6C19.1046 6 20 6.89543 20 8V20C20 21.1046 19.1046 22 18 22H10C8.89543 22 8 21.1046 8 20V8C8 6.89543 8.89543 6 10 6H18ZM15.5 18H10.5C10.2239 18 10 18.2239 10 18.5C10 18.7761 10.2239 19 10.5 19H15.5C15.7761 19 16 18.7761 16 18.5C16 18.2239 15.7761 18 15.5 18ZM17.5 18C17.2239 18 17 18.2239 17 18.5C17 18.7761 17.2239 19 17.5 19C17.7761 19 18 18.7761 18 18.5C18 18.2239 17.7761 18 17.5 18ZM15.5 16H10.5C10.2239 16 10 16.2239 10 16.5C10 16.7761 10.2239 17 10.5 17H15.5C15.7761 17 16 16.7761 16 16.5C16 16.2239 15.7761 16 15.5 16ZM17.5 16C17.2239 16 17 16.2239 17 16.5C17 16.7761 17.2239 17 17.5 17C17.7761 17 18 16.7761 18 16.5C18 16.2239 17.7761 16 17.5 16ZM15.5 14H10.5C10.2239 14 10 14.2239 10 14.5C10 14.7761 10.2239 15 10.5 15H15.5C15.7761 15 16 14.7761 16 14.5C16 14.2239 15.7761 14 15.5 14ZM17.5 14C17.2239 14 17 14.2239 17 14.5C17 14.7761 17.2239 15 17.5 15C17.7761 15 18 14.7761 18 14.5C18 14.2239 17.7761 14 17.5 14ZM13.5 9H10.5C10.2239 9 10 9.22386 10 9.5V10.5C10 10.7761 10.2239 11 10.5 11H13.5C13.7761 11 14 10.7761 14 10.5V9.5C14 9.22386 13.7761 9 13.5 9Z"
        fill="#1072EB"
      />
    </svg>
  )
}

export default Calculator
